<template>
  <div class="file-preview other-file-preview">
    <i class="el-icon-document"></i>
  </div>
</template>

<script>
export default {
  name: 'OtherPreview',
  props: {
    src: String
  }
}
</script>